export default function handleTrackingCookie() {
  const trackingParams = ['seccod', 'cid', 'bid', 'ecid']
  const requiredParams = ['mwmId', 'KI']
  const formCookieFunctionalName = 'aok-forms-functional'
  const formCookieTrackingName = 'aok-forms-tracking'

  const getUrlParameter = (sParam) => {
    const sPageURL = decodeURIComponent(window.location.search.substring(1))
    const sURLVariables = sPageURL.split('&')
    let sParameterName

    for (let i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split('=')

      if (sParameterName[0] === sParam) {
        return sParameterName[1] === undefined ? true : sParameterName[1]
      }
    }

    return null
  }

  const getCookie = (cname) => {
    const name = cname + '='
    const ca = document.cookie.split(';')

    for (let i = 0; i < ca.length; i++) {
      let c = ca[i]
      while (c.charAt(0) === ' ') {
        c = c.substring(1)
      }
      if (c.indexOf(name) === 0) {
        return decodeURIComponent(c.substring(name.length, c.length))
      }
    }
    return null
  }

  const setCookie = (cookieName, paramsToLog) => {
    const code = JSON.parse(getCookie(cookieName)) || []
    const cleanCodeObj = {}
    const newCode = []
    let domain = ''
    let logParamValue

    if (window.location.hostname !== 'localhost') {
      const reversedDomainParts = window.location.hostname.split('.').reverse()
      domain = 'domain=.' + reversedDomainParts[1] + '.' + reversedDomainParts[0]
    }

    paramsToLog.forEach((paramKey) => {
      Object.keys(code).forEach((key) => {
        if (key === paramKey) {
          cleanCodeObj[paramKey] = code[key]
        }
      })

      logParamValue = getUrlParameter(paramKey)
      if (logParamValue) {
        cleanCodeObj[paramKey] = logParamValue
      }
    })

    Object.keys(cleanCodeObj).forEach((key) => {
      newCode.push({
        key: key,
        value: cleanCodeObj[key],
      })
      let expires = ''
      if (key === 'cid' && cookieName === 'aok-forms-tracking') {
        expires = 'max-age=' + 30 * 24 * 60 * 60 + ';'
      }
      document.cookie =
        cookieName + '=' + encodeURIComponent(JSON.stringify(newCode)) + ';path=/;' + domain + ';' + expires
    })
  }

  document.addEventListener('onCookieSettingsChanged', function (event) {
    if (event.detail.cookieSettings['functional'].approved) {
      setCookie(formCookieFunctionalName, requiredParams)
    }
    if (event.detail.cookieSettings['tracking'].approved) {
      setCookie(formCookieTrackingName, trackingParams)
    }
  })

  document.addEventListener('onCookieSettingsInitialized', function () {
    if (window.CookieSettingsManager.getStatusForCategory('functional')) {
      setCookie(formCookieFunctionalName, requiredParams)
    }
    if (window.CookieSettingsManager.getStatusForCategory('tracking')) {
      setCookie(formCookieTrackingName, trackingParams)
    }
  })

  document.addEventListener('DOMContentLoaded', function () {
    if (typeof window.CookieSettingsManager === 'undefined') {
      setCookie(formCookieFunctionalName, requiredParams)
      setCookie(formCookieTrackingName, trackingParams)
    }
  })
}
